import styled from 'styled-components';

import { theme } from '@frontend/legacy-components/src/theme/theme';

/**
 * Helper function to check if the table needs a title section
 *
 * @deprecated use TableV2 and its subcomponents from '@frontend/legacy-components' instead.
 */
export const hasTitle = (headerOptions) => {
  if (headerOptions == null) {
    return false;
  }

  return (
    headerOptions.title != null ||
    headerOptions.leftComponent != null ||
    headerOptions.rightComponent != null ||
    headerOptions.customHeader != null
  );
};

const TitleBlockWrapper = styled.div`
  align-items: center;
  background-color: ${(props) => props.theme.colors.page.surface};
  color: ${(props) => props.theme.colors.feature.primary};
  display: flex;
  flex-direction: row;
  font-family: ${(props) => props.theme.fonts.default};
  justify-content: space-between;
  text-transform: capitalize;
  padding: 0.5rem 0.75rem;

  .leftSide .title {
    font-size: ${(props) => props.theme.fontSizes.lg};
    line-height: ${(props) => props.theme.lineHeights.lg};
    font-weight: ${(props) => props.theme.fontWeights.heavy};
    margin-right: 0.75rem;
    display: ${(props) => (props.title != null ? 'unset' : 'none')};
  }

  .rightSide .search {
    margin-left: 0.75rem;
    margin-right: -0.5rem;
    max-width: 12rem;
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .rightSide,
  .leftSide {
    align-items: center;
    display: flex;
    flex-direction: row;
  }
`;

TitleBlockWrapper.defaultProps = { theme };
// TITLE BLOCK: Optional auto-generated title section of the table.
// ------------------------------------------------------------------ //
const TitleBlock = ({ title, leftComponent, rightComponent }) => (
  <TitleBlockWrapper title={title}>
    <span className={'leftSide'}>
      <span className={'title'}>{title}</span>
      {leftComponent}
    </span>
    <span className={'rightSide'}>{rightComponent}</span>
  </TitleBlockWrapper>
);
// ------------------------------------------------------------------ //

export default TitleBlock;
